import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin: 50px auto 0;
  position: relative;
  padding: 0 0 50px;

  display: block;
  height: auto;
  width: 100%;
`;

export const TermsContainer = styled.div`
  padding: min(3.5vmax, 25px);
  background-color: white;

  min-height: 100dvh;
  position: relative;
  display: block;
`;

export const Title = styled.h3`
  text-transform: uppercase;
  text-align: center;
  color: rgb(0 0 0);

  font-weight: 700;
  margin: 0 auto;
  width: 80%;
`;
